import { createFileRoute } from '@tanstack/react-router';
import { Activity, Database, Cloud, Layers } from 'lucide-react';
import { Card } from '@/components/ui/card';

export const Route = createFileRoute('/_authenticated/admin/system')({
  component: SystemPage,
});

function SystemPage() {
  const services = [
    { name: 'pulse-collect', url: 'https://pulse-collect-preview.alivevietnam.com/health', icon: Activity },
    { name: 'pulse-api', url: 'https://pulse-api-preview.alivevietnam.com/health', icon: Cloud },
    { name: 'pulse-jobs', url: 'internal', icon: Layers },
  ];

  const bindings = [
    { name: 'D1 / pulse-metadata', icon: Database },
    { name: 'R2 / pulse-replays', icon: Database },
    { name: 'KV / pulse-config', icon: Database },
    { name: 'Queue / pulse-jobs', icon: Layers },
    { name: 'Analytics Engine / pulse_events', icon: Activity },
  ];

  return (
    <div className="mx-auto max-w-5xl px-6 py-8 animate-fade-up">
      <header className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold tracking-tight">System health</h1>
        <p className="text-sm text-text-muted">Workers + Cloudflare resources status.</p>
      </header>

      <h2 className="mb-3 text-xs font-semibold uppercase tracking-wider text-text-muted">Workers</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-8">
        {services.map((s) => (
          <Card key={s.name} className="p-4 flex items-center gap-3">
            <s.icon className="size-4 text-text-muted" />
            <div className="min-w-0">
              <div className="text-sm font-medium">{s.name}</div>
              <div className="text-[11px] text-text-muted font-mono truncate">{s.url}</div>
            </div>
          </Card>
        ))}
      </div>

      <h2 className="mb-3 text-xs font-semibold uppercase tracking-wider text-text-muted">Bindings</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {bindings.map((b) => (
          <Card key={b.name} className="p-4 flex items-center gap-3">
            <b.icon className="size-4 text-text-muted" />
            <div className="text-sm font-medium">{b.name}</div>
          </Card>
        ))}
      </div>

      <p className="mt-8 text-xs text-text-muted">
        Live metrics, queue depth, R2 size, and error rates will be added when the Cloudflare Workers Analytics API integration lands.
      </p>
    </div>
  );
}
